import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';

export const fetchOrdersSummarySuccess = ( hardwoodRemaining,cedarRemaining,blackRemaining,redRemaining,totalBagsSold ) => {
    return {
        type: actionTypes.FETCH_ORDERSSUMMARY_SUCCESS,
        hardwoodRemaining: hardwoodRemaining,
        cedarRemaining: cedarRemaining,
        blackRemaining: blackRemaining,
        redRemaining: redRemaining,
        totalBagsSold: totalBagsSold
    };
};

export const tickOrdersSummary = () => {
    return dispatch => {
        if (localStorage.getItem('token') != null)
        {
            let site = window.location.hostname;
        site = site.replace('mulch','');
        if (site === '') {
            site = 'local';
        }
        axios.post( 'https://api.mescout.org/api/MulchOrder/GetOrdersSummary?site=' + site + '&sessionId=' + localStorage.getItem('token'))
            .then( res => {
                dispatch(fetchOrdersSummarySuccess(res.data.HardwoodRemaining,res.data.CedarRemaining,res.data.BlackRemaining,res.data.RedRemaining,res.data.TotalBagsSold));
            } )
            .catch( err => {
                
            } );
        }
    };
};




// WEBPACK FOOTER //
// ./src/store/actions/ordersSummary.js